import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class ServiceRequestService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  // getServiceRequestData(jobCardID: string) {
  //   let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
  //   return this.http.get(this.apiURL + "/api/ServiceRequest/" + jobCardID, requestOptions)
  //     .pipe(map((res: any) => {return res;}),
  //       catchError((res: any) => { return throwError(res.json()) }));
  // }

  getServiceRequestData(jobCardID: string, returnNewNotes: boolean = false) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Portal/Workshop/Calendar/JobCard/${jobCardID}?code=${this.env.key}` + (returnNewNotes ? '&returnNewNotes=true' : ''),
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getManageJobCardDetails(jobCardID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/V3/Portal/Workshop/Calendar/JobCard/${jobCardID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getManageJobCardLinkedServices(jobCardID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Portal/Workshop/Calendar/JobCard/${jobCardID}/LinkedServiceTypes?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getLinkedJobCards(partnerID: number, jobcardID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/store/${partnerID}/LinkedServiceJobs/${jobcardID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchServiceRequest(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/ServiceRequest/Search', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  jobCardServiceRequest(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/ServiceRequest/JobCardSearch',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveServiceRequest(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/ServiceRequest', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  relinkService(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(
        this.apiURL + '/api/ServiceRequest/RelinkService',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveTechnicianNote(jobCardID: string, Note: string, countryData: any) {
    let body = {
      ID: jobCardID,
      Note: Note + '<br>',
      Date: moment().format(countryData.MomentDateFormat),
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/ServiceRequest/TechnicianNotes',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveAssessmentNote(jobCardID: string, Note: string, countryData: any) {
    let body = {
      ID: jobCardID,
      Note: Note + '<br>',
      Date: moment().format(countryData.MomentDateFormat),
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/ServiceRequest/AssessmentNotes',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateAssessmentNote(jobCardID: string, Note: string) {
    let body = { ID: jobCardID, Note: Note };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(
        this.apiURL + '/api/ServiceRequest/AssessmentNotes',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveInternalNote(jobCardID: string, Note: string, countryData: any) {
    let body = {
      ID: jobCardID,
      Note: Note + '<br>',
      Date: moment().format(countryData.MomentDateFormat),
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/ServiceRequest/InternalNotes',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateInternalNote(jobCardID: string, Note: string) {
    let body = { ID: jobCardID, Note: Note };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(
        this.apiURL + '/api/ServiceRequest/InternalNotes',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateMarketingConsent(cyclistID, partnerID, consentState) {
    let data = {
      UserID: cyclistID,
      PartnerID: partnerID,
      Consent: consentState,
    };
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .post(
        this.env.url + `/Services/PostMarketingConsent?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateClientNote(jobCardID: string, Note: string) {
    let body = { ID: jobCardID, Note: Note };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(
        this.apiURL + '/api/ServiceRequest/ClientNotes',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceCustomQuestions(partnerID, serviceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Workshop/${partnerID}/Service/${serviceID}/CustomQuestions/Responses?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  updateServiceCustomQuestionResponses(partnerID, serviceID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Workshop/${partnerID}/Service/${serviceID}/CustomQuestions/Responses?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  updateJobCardSlot(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/ServiceRequest/UpdateJobcardSlot',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  bookIn(jobCardId: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/ServiceRequest/' + jobCardId + '/BookIn',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  CustomStatus(jobCardId: string, sendComms: boolean = true, statusId: number) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/ServiceRequest/' + jobCardId + '/custom/' + statusId,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  assignToTechnician(
    jobCardId: string,
    technicianId: string,
    sendComms: boolean = true,
  ) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardId +
        '/AssignToTechnician/' +
        technicianId +
        '?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  waitingForWork(jobCardId: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardId +
        '/WaitingForWork?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  bikeReceived(jobCardId: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardId +
        '/BikeReceived?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  startWork(jobCardId: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardId +
        '/StartWork?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  startWarrantyWork(jobCardId: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardId +
        '/StartWarrantyWork?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getGearReplacementFromPOS(jobCardId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardId +
        '/GetGearReplacementListFromPOS',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError('Unable to get gear replacement info');
        }),
      );
  }

  completeWork(jobCardID: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardID +
        '/CompleteWork?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  readyForCollection(jobCardID: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardID +
        '/ReadyForCollection?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  readyForCollectionV2(jobCardID: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardID +
        '/V2/ReadyForCollection?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  jobCompleted(jobCardID: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardID +
        '/JobCompleted?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  collect(jobCardID: string, sendComms: boolean = true) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardID +
        '/Collect?SendCommunication=' +
        sendComms,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  cancelJob(
    jobCardID: string,
    reason: string,
    otherReason: string,
    wasTesting: boolean = false,
  ) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardID +
        '/Cancel?reason=' +
        reason +
        (otherReason ? '&otherReason=' + otherReason : '') +
        (wasTesting ? '&wasTesting=true' : ''),
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  iNeedHelp(jobCardID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/ServiceRequest/' + jobCardID + '/INeedHelp',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  undoBikeReceived(jobCardID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/ServiceRequest/' + jobCardID + '/UndoBikeReceived',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  reopenJobcard(jobCardID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/ServiceRequest/' + jobCardID + '/ReopenJobcard',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  waitingForParts(jobCardID: string, sendComms: boolean = true) {
    let body = { ID: jobCardID, Note: 'Waiting for parts' + '<br>' };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL +
        '/api/ServiceRequest/PauseWaitingForParts?SendCommunication=' +
        sendComms,
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  waitingForClient(jobCardID: string, sendComms: boolean = true) {
    let body = { ID: jobCardID, Note: 'Waiting for client' + '<br>' };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL +
        '/api/ServiceRequest/PauseWaitingForClient?SendCommunication=' +
        sendComms,
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getTechniciansForServiceType(serviceTypeID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/ServiceType/${serviceTypeID}/Technicians`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveTechniciansForServiceType(request: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/ServiceType/Technicians`,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  linkTechniciansForServiceType(request: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/ServiceType/LinkTechnician`,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  unlinkTechniciansForServiceType(request: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/ServiceType/UnLinkTechnician`,
        request,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCollection(id: number) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + `/api/ServiceRequest/${id}/GetCollection`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCollectionV2(serviceID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Portal/JobCardCollections/${serviceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateCollection(collection: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(
        this.apiURL + `/api/ServiceRequest/UpdateCollection`,
        collection,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  importServices(partnerID, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/ServiceImports?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  submitServiceComplaint(serviceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Services/ComplaintReceived/${serviceID}?code=${this.env.key}`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobCardWaiver(partnerID, serviceID, IsFitting) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Workshop/${partnerID}/Service/${serviceID}/Waiver?IsFitting=${IsFitting}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getWorkshopAvailability(partnerID: number, fromDate: string, toDate: string, serviceTypeID: string = '', technicianID = '') {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Partner/${partnerID}/Workshop/Availability?FromDate=${fromDate}&ToDate=${toDate}&ServiceTypeID=${serviceTypeID}&TechnicianID=${technicianID}&DefaultServiceTime=&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }


  updateWorkshopJobCard(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Portal/Workshop/JobCard?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveOverride(partnerId, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/partner/${partnerId}/FittingsAvailabilityOverride?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getOverride(partnerId, serviceTypeId) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/partner/${partnerId}/FittingsAvailabilityOverride/${serviceTypeId}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  deleteOverride(partnerId, id) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/partner/${partnerId}/FittingsAvailabilityOverride/${id}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }



  getCalendarSearch(partnerID, type, value, page, searchAll) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/workshop/${partnerID}/calendar/search/${type}/${value}/${page}?allStores=${searchAll}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getBays(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/workshop/${partnerID}/bays?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveBays(partnerId, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/workshop/${partnerId}/bays?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  deleteBays(partnerId, id) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/workshop/${partnerId}/bays/${id}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getTags(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/workshop/${partnerID}/tags?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveTags(partnerId, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/workshop/${partnerId}/tags?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  deleteTags(partnerId, id) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/workshop/${partnerId}/tags/${id}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceTags(partnerID, jobId) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/workshop/${partnerID}/job/${jobId}/tags?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveServiceTags(partnerId, jobId, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/workshop/${partnerId}/job/${jobId}/tags?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  deleteServiceTags(partnerId, jobId, tagId) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/workshop/${partnerId}/job/${jobId}/tags/${tagId}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

}
